import {
  CURRENT_QUERY_BUILDER_VERSION,
  QueryBuilderModel,
  srs,
} from 'vet-bones/utils/queryBuilder';

import { ModelRuleType } from 'src/containers/ProjectDiagram/types/data';
import { ProjectModelRule } from 'src/store/state/projects';
import { RDFS_LABEL_IRI } from 'src/templates/queries/iris';
import { ModelRulesBindingResult } from 'src/templates/queries/modelRules';

export const parseModelRuleResults = (
  results: ModelRulesBindingResult[],
  modelName: string,
  queryBuilderModel: QueryBuilderModel,
  namespaces: Record<string, string>
) => {
  let newRuleIdx = 0;
  const rules: Record<string, ProjectModelRule> = {};
  results.forEach((result: ModelRulesBindingResult) => {
    const { iri, ruleLabel, ruleContent } = result;
    const parsed = srs(ruleContent.value || '', queryBuilderModel, namespaces, {
      stardogLabelIri: RDFS_LABEL_IRI,
    });

    let name = ruleLabel?.value;
    if (!name) {
      newRuleIdx += 1;
      name = `${modelName} rule (${newRuleIdx})`;
    }

    const rule: ProjectModelRule = {
      id: iri.value,
      name,
      ifClause: null,
      thenClause: null,
      text: ruleContent.value,
      type: ModelRuleType.TEXT,
    };

    if (parsed?.rules.length === 1) {
      rule.ifClause = {
        version: CURRENT_QUERY_BUILDER_VERSION,
        data: {
          query: parsed.rules[0].ifTopExpression,
          variableIds: [],
        },
      };
      rule.thenClause = {
        version: CURRENT_QUERY_BUILDER_VERSION,
        data: {
          query: parsed.rules[0].thenTopExpression,
          variableIds: [],
        },
      };
    }

    rules[rule.id] = rule;
  });

  return rules;
};
